// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.overview .card-summary {
  background-color: #ffffff;
  display: flex;
  padding: 20px;
  border-radius: 7px;
  border: 1px solid #e6e6e6;
}

.overview .card-summary p {
  margin-bottom: 0;
}

.overview .summary-icon {
  margin-right: auto;
  margin-left: 0;
}

.overview .summary-icon img {
  width: 50px;
}

.overview .data {
  text-align: end;
  font-size: 10px;
}

.overview .data .amount {
  font-size: 18px;
  letter-spacing: 0.1px;
  color: #000000;
}

.overview .data .amount span {
  font-weight: 600;
  margin-left: 2px;
}

.overview .chart {
  background-color: #ffffff;
  border-radius: 6px;
  padding: 60px;
  width: 100%;
  height: 370px;
}

.overview .commission-summary h6 {
  font-size: 10px;
  color: #8d8d8d;
  margin-bottom: 0;
}

.overview .commission-summary .withdrawal {
  color: #1d0d7b;
  font-weight: 800;
  font-size: 16px;
  margin-bottom: 0;
}

.overview .assigned-agent-summary {
  background-color: #ffffff;
  border: 2px dashed #e4e2e2;
  border-radius: 6px;
}

.overview .assigned-agent-summary .agent-count {
  text-align: center;
  padding: 30px;
  border-right: 2px dashed #e4e2e2;
}

.overview .assigned-agent-summary .agent-count span {
  font-size: 36px;
  font-weight: 600;
  color: #060d27;
}

.overview .assigned-agent-summary .circle-progress {
  width: 70%;
  margin-top: 20px;
  text-align: center;
  font-size: 12px;
}

.overview .weekly-summary {
  background-color: #ffffff;
  padding: 15px 10px 36px;
  box-shadow: 0px 3px 20px #00000029;
  border-radius: 6px;
}

.overview .weekly-summary .chart-doughnut {
  width: 130px;
  height: 100px;
}

.overview .weekly-summary .view-performance-btn {
  background-color: #3ce5c8;
  padding: 8px 20px;
  box-shadow: 0px 3px 6px #00000029;
  border: 1px solid #060d27;
  border-radius: 8px;
  margin-left: 60px;
}

.overview .commission-progress {
  height: 16px !important;
  border-radius: 0 !important;
  margin-bottom: 5px;
}

.overview .progress-bar {
  border-radius: 0 !important;
  background-color: #1d0d7b !important;
}
`, "",{"version":3,"sources":["webpack://./src/view/user-dashboard/Dashboard.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,aAAa;EACb,aAAa;EACb,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,aAAa;AACf;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,iCAAiC;EACjC,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,oCAAoC;AACtC","sourcesContent":[".overview .card-summary {\n  background-color: #ffffff;\n  display: flex;\n  padding: 20px;\n  border-radius: 7px;\n  border: 1px solid #e6e6e6;\n}\n\n.overview .card-summary p {\n  margin-bottom: 0;\n}\n\n.overview .summary-icon {\n  margin-right: auto;\n  margin-left: 0;\n}\n\n.overview .summary-icon img {\n  width: 50px;\n}\n\n.overview .data {\n  text-align: end;\n  font-size: 10px;\n}\n\n.overview .data .amount {\n  font-size: 18px;\n  letter-spacing: 0.1px;\n  color: #000000;\n}\n\n.overview .data .amount span {\n  font-weight: 600;\n  margin-left: 2px;\n}\n\n.overview .chart {\n  background-color: #ffffff;\n  border-radius: 6px;\n  padding: 60px;\n  width: 100%;\n  height: 370px;\n}\n\n.overview .commission-summary h6 {\n  font-size: 10px;\n  color: #8d8d8d;\n  margin-bottom: 0;\n}\n\n.overview .commission-summary .withdrawal {\n  color: #1d0d7b;\n  font-weight: 800;\n  font-size: 16px;\n  margin-bottom: 0;\n}\n\n.overview .assigned-agent-summary {\n  background-color: #ffffff;\n  border: 2px dashed #e4e2e2;\n  border-radius: 6px;\n}\n\n.overview .assigned-agent-summary .agent-count {\n  text-align: center;\n  padding: 30px;\n  border-right: 2px dashed #e4e2e2;\n}\n\n.overview .assigned-agent-summary .agent-count span {\n  font-size: 36px;\n  font-weight: 600;\n  color: #060d27;\n}\n\n.overview .assigned-agent-summary .circle-progress {\n  width: 70%;\n  margin-top: 20px;\n  text-align: center;\n  font-size: 12px;\n}\n\n.overview .weekly-summary {\n  background-color: #ffffff;\n  padding: 15px 10px 36px;\n  box-shadow: 0px 3px 20px #00000029;\n  border-radius: 6px;\n}\n\n.overview .weekly-summary .chart-doughnut {\n  width: 130px;\n  height: 100px;\n}\n\n.overview .weekly-summary .view-performance-btn {\n  background-color: #3ce5c8;\n  padding: 8px 20px;\n  box-shadow: 0px 3px 6px #00000029;\n  border: 1px solid #060d27;\n  border-radius: 8px;\n  margin-left: 60px;\n}\n\n.overview .commission-progress {\n  height: 16px !important;\n  border-radius: 0 !important;\n  margin-bottom: 5px;\n}\n\n.overview .progress-bar {\n  border-radius: 0 !important;\n  background-color: #1d0d7b !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
